// FILE: /blog_hooks/usePrivateBlogs.js
import { useEffect, useState, useCallback } from "react";
import api from "../../axios/axiosInstance";

/**
 * Hook to fetch blogs created by the logged-in user.
 * Supports manual refresh trigger.
 */
const usePrivateBlogs = (withManualTrigger = false) => {
    const [blogs, setBlogs] = useState([]);
    const [refreshFlag, setRefreshFlag] = useState(0);

    const fetchBlogs = useCallback(() => {
        api
            .get("/grades/blog-list-private/")
            .then((res) => {
                const data = Array.isArray(res.data) ? res.data : [];
                setBlogs(data);
            })
            .catch((err) => {
                console.error("Error fetching private blogs:", err);
                setBlogs([]);
            });
    }, []);

    useEffect(() => {
        fetchBlogs();
    }, [fetchBlogs, refreshFlag]);

    const refresh = useCallback(() => setRefreshFlag((prev) => prev + 1), []);

    return withManualTrigger ? [blogs, refresh] : blogs;
};

export default usePrivateBlogs;
